// Product photos. Caption pills on the first photos (Theme settings > DC product photos).
// When the desktop layout uses thumbnails, a CRAFTD-style carousel: The thumbnail strip is hidden (see dc.css);
// arrows and dots on the main photo drive Dawn's own thumbnail buttons, so zoom and variant switching keep working.
(function () {
  var mq = window.matchMedia('(min-width: 750px)');
  var arrow = function (d) { return '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="' + (d < 0 ? 'M12.5 4 6.5 10l6 6' : 'M7.5 4l6 6-6 6') + '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };
  function setup(gallery) {
    if (gallery.dataset.dcNav) return;
    var list = gallery.querySelector('.thumbnail-list');
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!list || !viewer) return;
    if (gallery.querySelector('.thumbnail-slider.medium-hide')) return; // grid layout on desktop: no arrows needed
    var buttons = function () { return Array.prototype.slice.call(list.querySelectorAll('.thumbnail-list__item:not(.thumbnail-list_item--variant) .thumbnail')); };
    if (buttons().length < 2) return;
    gallery.dataset.dcNav = '1';
    var nav = document.createElement('div');
    nav.className = 'dc-gnav';
    nav.innerHTML = '<button type="button" class="dc-gnav__btn dc-gnav__btn--prev" aria-label="Previous photo">' + arrow(-1) + '</button>' +
      '<button type="button" class="dc-gnav__btn dc-gnav__btn--next" aria-label="Next photo">' + arrow(1) + '</button>' +
      '<div class="dc-gnav__dots" aria-hidden="true"></div>';
    viewer.appendChild(nav);
    var dots = nav.querySelector('.dc-gnav__dots');
    var current = function () { var b = buttons(); return Math.max(0, b.findIndex(function (x) { return x.getAttribute('aria-current') === 'true'; })); };
    var render = function () { var b = buttons(), i = current(); dots.innerHTML = b.map(function (_, n) { return '<span' + (n === i ? ' class="is-on"' : '') + '></span>'; }).join(''); };
    var go = function (step) { var b = buttons(); if (!b.length) return; b[(current() + step + b.length) % b.length].click(); };
    nav.querySelector('.dc-gnav__btn--prev').addEventListener('click', function () { go(-1); });
    nav.querySelector('.dc-gnav__btn--next').addEventListener('click', function () { go(1); });
    new MutationObserver(render).observe(list, { attributes: true, subtree: true, attributeFilter: ['aria-current', 'class'] });
    gallery.addEventListener('keydown', function (e) {
      if (!mq.matches || e.target.closest('input, select, textarea')) return;
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
    render();
  }
  function captions(gallery) {
    var texts = (window.dcGalleryBadges || []).map(function (t) { return String(t).trim(); }).filter(Boolean);
    if (!texts.length || gallery.dataset.dcCaps) return;
    gallery.dataset.dcCaps = '1';
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-list > .product__media-item'))
      .filter(function (li) { return !li.classList.contains('product__media-item--variant') && getComputedStyle(li).display !== 'none'; });
    items.slice(0, texts.length).forEach(function (li, i) {
      var pill = document.createElement('span');
      pill.className = 'dc-gcap';
      pill.textContent = texts[i];
      li.appendChild(pill);
    });
  }
  var init = function () { document.querySelectorAll('media-gallery').forEach(function (g) { setup(g); captions(g); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
